import { marked } from "marked"
import { configureFSS3 } from "src/context/AuthContextUtility"
import { Storage } from "aws-amplify";

export const getResultContent = async (data) => {
  let mdContent = ''
  let jsonData = await loadResultsFromS3(data)
  if (jsonData?.status_report?.result) {
    mdContent += '------------------------\n'
    mdContent += '# ***Overall summary***  \n ------------------------  \n. \n'
    mdContent += `${jsonData.status_report.result}\n`
  }
  if (jsonData?.analysis) {
    mdContent += '------------------------\n'
    mdContent += '# ***Analysis***  \n ------------------------  \n. \n'
    mdContent += `${jsonData.analysis}\n`
  }
  if (jsonData?.checks?.length > 0) {
    mdContent += '------------------------\n'
    mdContent += '# ***Checks***  \n ------------------------  \n. \n'
    for (let check of jsonData.checks) {
      mdContent += `${check.analysis}\n`
    }
  }
  const htmlContent = marked.parse(mdContent);
  return { 'html': htmlContent, 'markdown': mdContent }
}



export const loadResultsFromS3 = async (data) => {
  configureFSS3()
  const fullPath = new URL(data?.response_s3_path)?.pathname?.substring(1);

  // Split into prefix (directory path) and filename
  const lastSlashIndex = fullPath.lastIndexOf('/');
  const prefix = fullPath.substring(0, lastSlashIndex + 1); // Include trailing slash
  const key = fullPath.substring(lastSlashIndex + 1); // Just the filename

  const result = await Storage.get(key, { customPrefix: { public: prefix }, expires: 60, download: true });
  const text = await result.Body.text();
  const jsonData = JSON.parse(text);
  return jsonData
}